import { Button, Divider } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useDpiaContext } from '../dpia.context';
import { nameCondition, nameConditionRisk } from './Step5';
import moment from 'moment';

const notIncludedId = 'fd1c9eb8629411ee867dfa163e89e3c8';

export const opinionCondition = (condition, t) => {
    if (condition) {
        return t('Agree');
    } else if (condition === false) {
        return t('Disagree');
    } else {
        return '-';
    }
};

export default function StepPreview({ values, ...props }) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { identificationList, impact, measures, refSave, dataflow } =
        useDpiaContext();

    const [dpiaIdentificationLists, setDpiaIdentificationLists] = useState();
    const [dpiaDescriptionLists, setDpiaDescriptionLists] = useState();
    const [dpiaConsultationLists, setDpiaConsultationLists] = useState();
    const [
        dpiaNecessaryProportionalityLists,
        setDpiaNecessaryProportionalityLists,
    ] = useState();
    const [dpiaRiskAssessmentLists, setRiskAssessmentLists] = useState();
    const [dpiaMeasureLists, setDpiaMeasureLists] = useState();
    const [dpiaPlaning, setDpiaPlaning] = useState();
    const [dpiaMonitoring, setDpiaMonitoring] = useState();
    const [dpiaDataFlow, setDpiaDataFlow] = useState();
    useEffect(() => {
        if (
            values?.identification?.dpiaIdentificationList &&
            identificationList
        ) {
            const newDpiaIdentificationList =
                values?.identification?.dpiaIdentificationList.map(
                    (iden, i) => {
                        const find = identificationList.find(
                            (d) => d.mDpiaIdentificationId === iden
                        );
                        return {
                            mDpiaIdentificationId: iden,
                            dpiaIdentificationName:
                                find?.dpiaIdentificationName,
                            sequence: i + 1,
                        };
                    }
                );
            setDpiaIdentificationLists(newDpiaIdentificationList);
        }

        if (values?.riskAssessment?.dpiaRiskAssessmentList && impact) {
            const newDpiaRiskAssessmentListWithImpact =
                values?.riskAssessment?.dpiaRiskAssessmentList.map((risk) => {
                    const dpiaRiskAssessmentImpactListWithImpact =
                        risk?.dpiaRiskAssessmentImpactList.map((impactData) => {
                            const matchingImpact = impact.find(
                                (impactItem) =>
                                    impactItem.dpiaImpactOrganizeId ===
                                    impactData
                            );
                            return matchingImpact;
                        });

                    return {
                        ...risk,
                        dpiaRiskAssessmentImpactList:
                            dpiaRiskAssessmentImpactListWithImpact,
                    };
                });
            setRiskAssessmentLists(newDpiaRiskAssessmentListWithImpact);
        }

        if (values?.measures?.dpiaMitigating && measures) {
            const newDpiaMeatureList = values?.measures?.dpiaMitigating.map(
                (measure, i) => {
                    const find = measures.find(
                        (d) => d.dpiaMitigatingMeasuresOrganizeId === measure
                    );

                    const findMeature =
                        values?.measures?.dpiaMitigatingMeasuresList.find(
                            (d) =>
                                d.dpiaMitigatingMeasuresOrganizeId ===
                                find?.dpiaMitigatingMeasuresOrganizeId
                        );

                    return {
                        considerationBy: findMeature?.considerationBy,
                        considerationResult: findMeature?.considerationResult,
                        effectOnRisk: findMeature?.effectOnRisk,
                        remainingRisk: findMeature?.remainingRisk,
                        dpiaMitigatingMeasuresOrganizeId: measure,
                        dpiaMitigatingMeasuresOrganizeName:
                            find?.dpiaMitigatingMeasuresOrganizeName,
                        sequence: i + 1,
                    };
                }
            );
            setDpiaMeasureLists(newDpiaMeatureList);
        }

        if (values?.description) {
            setDpiaDescriptionLists(values?.description);
        }
        if (values?.consultation) {
            setDpiaConsultationLists(values?.consultation);
        }
        if (values?.necessaryProportionality) {
            setDpiaNecessaryProportionalityLists(
                values?.necessaryProportionality
            );
        }
        if (values?.planning) {
            setDpiaPlaning(values?.planning);
        }
        if (values?.monitoring) {
            setDpiaMonitoring(values?.monitoring);
        }
        if (values?.dataFlow?.dataflowList && dataflow) {
            const dataFlowFilterd = dataflow?.filter((obj) => {
                return values?.dataFlow?.dataflowList?.includes(
                    obj.businessProcessId
                );
            });
            const dataFlowList = dataFlowFilterd?.map((obj, i) => {
                return { ...obj, sequence: i + 1 };
            });
            setDpiaDataFlow(dataFlowList);
        }
    }, [dataflow, identificationList, impact, measures, values]);

    return (
        <div hidden={!props?.isActive}>
            <div className="flex justify-between m-0">
                <h1 className="text-2xl font-semibold text-gray-dark">
                    {t('DPIA for Job Applications')}
                </h1>
                <Button
                    onClick={() => refSave?.current?.click()}
                    size="large"
                    type="primary"
                    className="px-8"
                >
                    {t('Save')}
                </Button>
            </div>
            <Divider />
            <div className="space-y-4">
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('The Data Flow tasks related to this DPIA')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(1)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <ul className="pl-4">
                    {dpiaDataFlow && dpiaDataFlow.length > 0 ? (
                        dpiaDataFlow.map((is) => {
                            return (
                                <li key={is.sequence}>
                                    {is.businessProcessName}
                                </li>
                            );
                        })
                    ) : (
                        <p className="-ml-4">-</p>
                    )}
                </ul>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 1 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(1)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t('Recording the essential criteria for DPIA preparation')}
                </p>
                {dpiaIdentificationLists &&
                dpiaIdentificationLists.length > 0 ? (
                    dpiaIdentificationLists.map((is) => {
                        if (notIncludedId.includes(is.mDpiaIdentificationId)) {
                            return (
                                <li key={is.sequence}>
                                    {is.dpiaIdentificationName}{' '}
                                    <div className="pl-5">
                                        <div className="font-semibold">
                                            {t(
                                                'The reason why it is not necessary to do',
                                                {
                                                    ns: 'dpia',
                                                }
                                            )}{' '}
                                            :
                                        </div>
                                        <div className="whitespace-pre">
                                            {values?.identification?.reason}
                                        </div>
                                    </div>
                                </li>
                            );
                        } else
                            return (
                                <li key={is.sequence}>
                                    {is.dpiaIdentificationName}
                                </li>
                            );
                    })
                ) : (
                    <p>-</p>
                )}
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 2 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(2)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t('The nature of data processing')}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaDescriptionLists?.natureDescription
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                </div>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark">
                    {t('The scope of data processing')}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaDescriptionLists?.scopeDescription
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                </div>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark">
                    {t('The context of data processing')}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaDescriptionLists?.contextDescription
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                    <Divider dashed className="border-t-2" />
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t('The purpose of data processing')}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaDescriptionLists?.purposeDescription
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                </div>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 3 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(3)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t(
                        'Specify the reasons, methods, and timeframe for conducting consultations and receiving feedback'
                    )}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaConsultationLists?.consultation
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                </div>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 4 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(4)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t('Necessity and proportionality')}
                </p>
                <div className="text-sm text-gray-dark">
                    {dpiaNecessaryProportionalityLists?.necessaryProportionality
                        ?.map((item, index) => {
                            return (
                                <ul key={index}>
                                    <li className="font-semibold">
                                        {item?.topicName}
                                    </li>
                                    <p>{item?.topicDescription}</p>
                                </ul>
                            );
                        })
                        .sort((a, b) => a.sequence - b.sequence) || <p>-</p>}
                </div>

                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 5 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(5)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark">
                    {t('Source of risk')}
                </p>
                <ul className="list-decimal">
                    {dpiaRiskAssessmentLists &&
                    dpiaRiskAssessmentLists.length > 0
                        ? dpiaRiskAssessmentLists.map((risk) =>
                              risk?.risk ? (
                                  <li
                                      className="text-sm text-gray-dark"
                                      key={risk?.sequence}
                                  >
                                      {risk?.risk}
                                  </li>
                              ) : (
                                  <p>-</p>
                              )
                          )
                        : '-'}
                </ul>
                <Divider dashed className="border-t-2" />
                <p className="text-sm font-semibold">{t('Risk assessment')}</p>
                <ul className="list-decimal">
                    {dpiaRiskAssessmentLists &&
                    dpiaRiskAssessmentLists.length > 0
                        ? dpiaRiskAssessmentLists.map((risk) =>
                              risk?.risk ? (
                                  <>
                                      <li
                                          className="text-sm font-semibold mt-2"
                                          key={risk?.sequence}
                                      >
                                          {risk?.risk}
                                      </li>
                                      <ul className="list-disc pl-0">
                                          <p className="text-sm font-semibold my-2">
                                              {t('Impact of Risk Assessment', {
                                                  ns: 'dpia',
                                              })}
                                          </p>
                                          <li className="text-sm ml-6">
                                              {t('Likelihood', {
                                                  ns: 'dpia',
                                              })}{' '}
                                              :{' '}
                                              {nameCondition(
                                                  risk?.likelihood,
                                                  t
                                              )}
                                          </li>
                                          <li className="text-sm ml-6">
                                              {t('Severity', {
                                                  ns: 'dpia',
                                              })}{' '}
                                              :{' '}
                                              {nameCondition(risk?.severity, t)}
                                          </li>
                                          <li className="text-sm ml-6">
                                              {t('Risk Assessment Result', {
                                                  ns: 'dpia',
                                              })}{' '}
                                              :{' '}
                                              {nameConditionRisk(
                                                  risk?.results,
                                                  t
                                              )}
                                          </li>
                                      </ul>
                                      <ul className="list-disc pl-0">
                                          <p className="text-sm font-semibold my-2">
                                              {t('Impact of Data Processing', {
                                                  ns: 'dpia',
                                              })}
                                          </p>

                                          {risk?.dpiaRiskAssessmentImpactList &&
                                          risk?.dpiaRiskAssessmentImpactList
                                              .length > 0
                                              ? risk?.dpiaRiskAssessmentImpactList?.map(
                                                    (impactItem) => (
                                                        <li
                                                            className="text-sm ml-6"
                                                            key={
                                                                impactItem?.dpiaImpactOrganizeId
                                                            }
                                                        >
                                                            {
                                                                impactItem?.dpiaImpactOrganizeName
                                                            }
                                                        </li>
                                                    )
                                                )
                                              : '-'}
                                      </ul>
                                  </>
                              ) : (
                                  <p>-</p>
                              )
                          )
                        : '-'}
                </ul>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 6 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(6)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark pl-1">
                    {t('Risk mitigation measures')}
                </p>
                <ul>
                    {dpiaMeasureLists && dpiaMeasureLists.length > 0 ? (
                        dpiaMeasureLists.map((meatureItem) => (
                            <li
                                className="text-sm text-gray-dark ml-4"
                                key={meatureItem?.sequence}
                            >
                                {
                                    meatureItem?.dpiaMitigatingMeasuresOrganizeName
                                }
                            </li>
                        ))
                    ) : (
                        <p className="-ml-4">-</p>
                    )}
                </ul>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-1">
                    {t('Evaluate risk mitigation measures')}
                </p>
                <ul className="list-decimal">
                    {dpiaMeasureLists && dpiaMeasureLists.length > 0 ? (
                        dpiaMeasureLists.map((meatureItem) => (
                            <>
                                <li
                                    className="text-sm font-semibold text-gray-dark ml-4"
                                    key={meatureItem.sequence + 1}
                                >
                                    {
                                        meatureItem.dpiaMitigatingMeasuresOrganizeName
                                    }
                                </li>
                                <ul className="list-disc">
                                    <li key={meatureItem.sequence + 2}>
                                        {t('Impact on Risk', { ns: 'dpia' })} :{' '}
                                        {nameCondition(
                                            meatureItem.effectOnRisk,
                                            t
                                        )}
                                    </li>
                                    <li key={meatureItem.sequence + 3}>
                                        {t('Remaining Risk', { ns: 'dpia' })} :{' '}
                                        {nameConditionRisk(
                                            meatureItem.remainingRisk,
                                            t
                                        )}
                                    </li>
                                    <li key={meatureItem.sequence + 4}>
                                        {t('Assessment Result', {
                                            ns: 'dpia',
                                        })}{' '}
                                        :{' '}
                                        {nameCondition(
                                            meatureItem.considerationResult,
                                            t
                                        )}
                                    </li>
                                    <li key={meatureItem.sequence}>
                                        {t('Consideration By', {
                                            ns: 'dpia',
                                        })}{' '}
                                        : {meatureItem.considerationBy}
                                    </li>
                                </ul>
                            </>
                        ))
                    ) : (
                        <p className="-ml-4">-</p>
                    )}
                </ul>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 7 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(7)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Project Name')}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {dpiaPlaning?.projectName ? dpiaPlaning.projectName : '-'}
                </p>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Date of Implementation', { ns: 'dpia' })}
                </p>
                {dpiaPlaning?.startDate || dpiaPlaning?.endDate ? (
                    <ul>
                        {dpiaPlaning?.startDate && (
                            <li className="text-sm text-gray-dark pl-4">
                                {t('Start', { ns: 'dpia' })}{' '}
                                {moment(dpiaPlaning?.startDate).format(
                                    'DD/MM/YYYY'
                                )}
                            </li>
                        )}
                        {dpiaPlaning?.endDate && (
                            <li className="text-sm text-gray-dark pl-4">
                                {t('End', { ns: 'dpia' })}{' '}
                                {moment(dpiaPlaning?.endDate).format(
                                    'DD/MM/YYYY'
                                )}
                            </li>
                        )}
                    </ul>
                ) : (
                    <ul className="ml-1">
                        <li className="text-sm text-gray-dark pl-4">
                            {t('Start', { ns: 'dpia' })} -
                        </li>
                        <li className="text-sm text-gray-dark pl-4">
                            {t('End', { ns: 'dpia' })} -
                        </li>
                    </ul>
                )}
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Person Responsible', { ns: 'dpia' })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {dpiaPlaning?.projectOwner ? dpiaPlaning.projectOwner : '-'}
                </p>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Remaining Risk', { ns: 'dpia' })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {dpiaPlaning?.dpiaRemainingRisk
                        ? dpiaPlaning.dpiaRemainingRisk
                        : '-'}
                </p>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Opinion of the Data Protection Officer', {
                        ns: 'dpia',
                    })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {opinionCondition(dpiaPlaning?.opinionDpo, t)}
                    {dpiaPlaning?.dpoReason && ': ' + dpiaPlaning?.dpoReason}
                </p>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Results from Consultations and Feedback', {
                        ns: 'dpia',
                    })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {opinionCondition(dpiaPlaning?.opinionConsult, t)}
                    {dpiaPlaning?.consultReason &&
                        ': ' + dpiaPlaning?.consultReason}
                </p>
                <div className="flex justify-between bg-thinPurple p-3">
                    <h5 className="text-purple-PHX text-base m-0 self-center">
                        {t('step 8 title')}
                    </h5>
                    <div className="self-center">
                        <a onClick={() => props?.goToStep(8)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ display: 'block', margin: '0 auto' }}
                            >
                                <path
                                    d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('Monitored and Verified by', {
                        ns: 'dpia',
                    })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {dpiaMonitoring?.followUpBy
                        ? dpiaMonitoring?.followUpBy
                        : '-'}
                </p>
                <Divider dashed className="border-t-2" />
                <p className="font-semibold text-sm text-gray-dark pl-4">
                    {t('The Publication of this DPIA Document', {
                        ns: 'dpia',
                    })}
                </p>
                <p className="text-sm text-gray-dark pl-4">
                    {dpiaMonitoring?.publicationOfDocument
                        ? dpiaMonitoring?.publicationOfDocument
                        : '-'}
                </p>
            </div>
        </div>
    );
}
